import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';

import IconButton from "@material-ui/core/IconButton/index";
import Zoom from "@material-ui/core/Zoom/index";
import Tooltip from "@material-ui/core/Tooltip/index";
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {RutaService} from "../../../../services/_Sis/RutaService/RutaService";
import ModalExpedientes from "./ModalExpedientes";
import {CONFIG} from "../../../../settings/Config/Config";
import {DateFormat} from "../../../../settings/DateFormat/DateFormat";
import icon_ticket from "../../../../assets/img/icons/icon-ticket.svg";
import {HttpRequest} from "../../../../settings/HttpRequest/HttpRequest";
import {ExpedienteService} from "../../../../services/_Sis/ExpedienteService/ExpedienteService";
import BarraProgreso from "./BarraProgreso";


class ListaTabla extends Component {
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
	}
	
	eliminar = (item) => {
		let msg = `¿Deseas eliminar el expediente con id: ${item.id_expediente}?`;
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Eliminar') {
				ExpedienteService.Eliminar(item.id_expediente).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	
	ticket_de_entrega = (value) => {
		HttpRequest.export('texid', ['expediente'], {
			id_expediente: value.id_expediente
		}, true, 900, 900)
	};
	
	render() {
		
		const {lista} = this.props;
		
		const bg_icon_ticket = {
			backgroundImage: `url(${icon_ticket})`
		};
		
		return (
			<Paper style={{overflowX: "auto"}}>
				<Table className={'desing-acresco'}>
					<TableHead>
						<TableRow>
							<TableCell component="th" align={'left'} className={'w-40-px padding-20-L padding-20-R'}>
								ID
							</TableCell>
							<TableCell component="th" align={'left'}>Nombre</TableCell>
							<TableCell component="th" align={'left'}>CURP</TableCell>
							<TableCell component="th" align={'left'}>RFC</TableCell>
							<TableCell component="th" align={'center'}>Fecha de Ingreso</TableCell>
							<TableCell component="th" align={'left'}>Género</TableCell>
							<TableCell component="th" align={'left'}>Identificación Oficial</TableCell>
							<TableCell component="th" align={'left'}>Dirección</TableCell>
							<TableCell component="th" align={'left'}>Comprobante Ingresos</TableCell>
							<TableCell component="th" align={'center'}>Quién es quién</TableCell>
							<TableCell component="th" align={'center'}>Cta. Propia</TableCell>
							<TableCell component="th" align={'center'}>Documentos</TableCell>
							<TableCell component="th" align={'center'} className={'w-200-px'}>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{lista.map((item, key) => (
							<TableRow key={key}>
								<TableCell align={'left'} className={'padding-20-L padding-20-R'}>
									{item.id_expediente}
								</TableCell>
								<TableCell align={'left'}>{item.nombre_completo}</TableCell>
								<TableCell align={'left'}>{item.curp}</TableCell>
								<TableCell align={'left'}>{item.rfc}</TableCell>
								<TableCell align={'center'}>{DateFormat.FormatText(item.fecha_ingreso)}</TableCell>
								<TableCell align={'left'}>{item.sexo}</TableCell>
								<TableCell align={'left'}>{item.identificacion}</TableCell>
								<TableCell align={'left'}>{item.direccion}</TableCell>
								<TableCell align={'left'}>{item.comprobante_ingreso}</TableCell>
								<TableCell align={'center'}>{item.quien}</TableCell>
								<TableCell align={'center'}>{item.actua}</TableCell>
								<TableCell align={'center'}>
									<BarraProgreso color={item.color_expedientes} completed={(item.completed_expedientes || 0)} buffer={100} value={(item.value_expedientes || 0)} size={'150px'}/>
								</TableCell>
								{/*<TableCell align={'center'}>
									{item.activo === 1 ? (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "darkgreen",
											display: "inline-grid",
										}}>Activo</div>
									) : (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "#901C30",
											display: "inline-grid",
										}}>Inactivo</div>
									)}
								</TableCell>*/}
								<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
									<div className={'w-auto vertical-inline'}>
										<div className={'v-center'}>
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Expediente PDF">
												<IconButton aria-label="Expediente PDF" onClick={() => this.ticket_de_entrega(item)}>
													<div className={'bg-img-contain-x-center-y-center h-25-px w-25-px cursor-pointer'} style={bg_icon_ticket}/>
												</IconButton>
											</Tooltip>
										</div>
										<div className={'v-center'}>
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Eliminar">
												<IconButton aria-label="Eliminar" onClick={() => this.eliminar(item)}>
													<DeleteOutlined/>
												</IconButton>
											</Tooltip>
										</div>
										<div className={'v-center'}>
											<ModalExpedientes
												tipo={'edit'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
										<div className={'v-center'}>
											<ModalExpedientes
												tipo={'view'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Paper>
		)
	}
}

ListaTabla.propTypes = {
	lista: PropTypes.array.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ListaTabla;
